import { render, staticRenderFns } from "./PanelLayers.vue?vue&type=template&id=936abd9e&scoped=true"
import script from "./PanelLayers.vue?vue&type=script&lang=js"
export * from "./PanelLayers.vue?vue&type=script&lang=js"
import style0 from "./PanelLayers.vue?vue&type=style&index=0&id=936abd9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936abd9e",
  null
  
)

export default component.exports